<template>
	<paginated-search v-bind="{ schema, searchEntities, openEntity, createEntity, autoEnable: true }"></paginated-search>
</template>

<script>
	import PaginatedSearch from "@/components/Espresso/BackendPaginatedSearch.vue";
	import Admin from "@/models/admin.model.vue";

	export default {
		components: {
			PaginatedSearch,
		},
		data () {
			return {
				schema: Admin.getSchema(),
			};
		},
		methods: {
			openEntity(user) {
				this.$router.push(`/administrador/${user.id}`);
			},
			createEntity() {
				this.$router.push(`/administrador/novo`);
			},
			searchEntities(paginationParameters) {
				const searchParameters = Object.assign({
					role: "ADMIN",
					// status: "APPROVED",
				}, paginationParameters);
				return Admin.search(searchParameters);
			},
		},
	}
</script>